"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ionValueToJsObject = void 0;
var snakeCaseToCamelCase = function (str) { return str.replace(/_[a-z0-9]/g, function (group) { return group[1].toUpperCase(); }); };
var convertKeyToCamelCase = function (obj) {
    if (obj !== null && typeof obj === 'object') {
        if (Array.isArray(obj)) {
            return obj.map(convertKeyToCamelCase);
        }
        return Object.keys(obj).reduce(function (newObj, key) {
            var camelCaseKey = snakeCaseToCamelCase(key);
            newObj[camelCaseKey] = convertKeyToCamelCase(obj[key]);
            return newObj;
        }, {});
    }
    return obj;
};
var ionValueToJsObject = function (ionValue) { return convertKeyToCamelCase(JSON.parse(JSON.stringify(ionValue))); };
exports.ionValueToJsObject = ionValueToJsObject;
